export function parseDescription(description?: string | null) {
  const paddingText =
    // eslint-disable-next-line max-len
    '喵御宅(mfuns.net)是一个纯粹的二次元社区，这里充满了动漫、漫画、游戏、鬼畜、轻小说宅舞、音乐、cosplay等ACG元素。在喵御宅，您可以畅享弹幕视频、文章、图片和插画等作品，也可以成为创作者，分享你关于ACGN的创意和欢乐! 加入我们，一同探索这个充满创意和想象力的ACG世界！'
  if (!description) return paddingText
  const gblen = getGbLen(description)
  if (gblen < 120) {
    description = description + paddingText
  }
  if (gblen > 160) {
    description = description.substring(0, 160) + '...'
  }
  return description
}
